import { render, staticRenderFns } from "./CandidatesSelectMenu.vue?vue&type=template&id=aae9a200&lang=pug&"
import script from "./CandidatesSelectMenu.vue?vue&type=script&lang=js&"
export * from "./CandidatesSelectMenu.vue?vue&type=script&lang=js&"
import style0 from "./CandidatesSelectMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VList,VListItem,VMenu,VProgressCircular})
